import { Model, attr, hasMany } from '@elatonsev/js-models';
import ServiceModel from './ServiceModel';

export default class ServiceCategoryModel extends Model {
  name = attr('string');
  services = hasMany(ServiceModel);
}